module.exports = __webpack_public_path__ + "static/media/send_referral_icon.33a321ad.svg";